import { api } from './client';

export const httpUserLogin = (identifier, password) => api().post('auth/local', { identifier, password });

export const httpGetUsers = (params) => api().get('users', { params });

export const httpGetUser = (userId, params) => api().get(`users/${userId}`, { params });

export const httpPutUser = (userId, params) => api().put(`users/${userId}`, { params });
